import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { useGet, useSaveUpdate } from '../../hooks/process-data'
import ReactPlaceholder from 'react-placeholder/lib'
import { appUrl, doToast } from '../../utils'
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TimeCart from './components/TimeCart'
import { setCustomerTime } from '../../context/slices/session-customer'
import LoadingIcon from '../../components/loading/LoadingIcon'
import { toast } from 'react-toastify'
import { FormCustom, Input } from '../../components/form'
import { doRequestPost } from '../../api'
import Layout from '../home/theme/Layout'
import { savePendingPurchase, trackMetaInitiateCheckout } from '../../utils/metaPixel'

export default function CartView() {
  const [ready, setReady] = useState(false)
  const history = useHistory();
  const dispatch = useDispatch()

  const { id_customers_reservation_event_zone, cart_loading } = useSelector(state => state.sessioncustomer)
  const { sessionValidated, key_customer, isCustomer } = useSelector(state => state.session)
  const [execute, setExecute] = useState(false)
  const [loadingDelete, setLoadingDelete] = useState(false)

  const [cart, setCart] = useState({})
  const [coupon, setCoupon] = useState('')
  const [checkoutTracked, setCheckoutTracked] = useState(false)

  const { rows, isProcessing, setReload, error } = useGet({
    url: '/event/customer/cart/' + key_customer,
    execute: execute,
    callback: (r) => {
      setCoupon(r.key_coupon)
      dispatch(setCustomerTime())
    }
  })

  useEffect(() => {
    console.log('sessionValidated', sessionValidated)
    console.log('isCustomer', isCustomer)
    if (!sessionValidated || !isCustomer) {
      history.push(
        appUrl({
          url:
            '/cuenta/login?redirect=' +
            encodeURIComponent(appUrl({ url: '/carrito' })),
        })
      )
      return
    }
  }, [sessionValidated, history, isCustomer])

  useEffect(() => {
    if (id_customers_reservation_event_zone && !cart_loading) {
      setReload(true);
      setExecute(true)
    }
  }, [id_customers_reservation_event_zone, setReload, cart_loading])

  useEffect(() => {
    if (error) {
      history.push(appUrl({ url: '/' }))
    } else if (!isProcessing) {
      if (!rows) {
        history.push(appUrl({ url: '/' }))
      } else {
        setCart(rows)
        setReady(true)
      }
    }
  }, [rows, error, isProcessing, history])

  const getSubtotal = useCallback(() => {
    let taxValue = .16
    let total = 0
    let total_charge_service = 0;

    cart?.details?.forEach(r => {
      total += parseFloat(r.total)
      if (!isNaN(parseFloat(r.charge_service_event_zone))) {
        total_charge_service += parseFloat(r.charge_service_event_zone)
      }
    })

    let amount_coupon = 0
    let total_before_coupon = 0;
    if (cart.id_coupon) {
      if (!isNaN(parseFloat(cart.total_coupon_discount))) {
        amount_coupon = parseFloat(cart.total_coupon_discount);
      }
      total_before_coupon = total;
      total -= amount_coupon
    }

    total -= total_charge_service

    let subtotal = parseFloat(total).toFixed(2)
    let iva = (total - parseFloat(total / (1 + taxValue))).toFixed(2)

    total += total_charge_service

    // cambiar en frontend/backend
    let cargo_por_orden = parseFloat(((total * 0.04) * 1.16) + 5)

    if (cart?.details?.length === 1 && parseInt(cart?.details[0]?.id_event) === 65) {
      cargo_por_orden = parseFloat(((total * 0.03)))
    }

    total += cargo_por_orden

    return {
      taxValue: taxValue * 100,
      total: total.toFixed(2),
      subtotal,
      iva: iva,
      amount_coupon: amount_coupon.toFixed(2),
      total_before_coupon: total_before_coupon.toFixed(2),
      total_charge_service: total_charge_service.toFixed(2),
      cargo_por_orden: cargo_por_orden.toFixed(2)
    }
  }, [cart])

  useEffect(() => {
    if (!ready || checkoutTracked || !cart?.details?.length) return
    const totals = getSubtotal()
    trackMetaInitiateCheckout({
      value: parseFloat(totals.total) || 0,
      currency: 'MXN',
      num_items: cart.details.length,
    })
    setCheckoutTracked(true)
  }, [ready, checkoutTracked, cart?.details, getSubtotal])

  const dataSubmit = useMemo(() => {
    return {
      p_id_customers: id_customers_reservation_event_zone,
      p_name_customer: cart?.name_customer,
      p_last_name_customer: cart?.last_name_customer,
      p_email_customer: cart?.email_customer,
      p_phone_customer: cart?.phone_customer,
      p_cargo_por_orden: getSubtotal().cargo_por_orden
    }
  }, [
    id_customers_reservation_event_zone,
    cart?.name_customer,
    cart?.last_name_customer,
    cart?.email_customer,
    cart?.phone_customer,
    getSubtotal
  ])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/event/mercadopago/pay',
    setReload: ({ link_pay }) => {
      window.location.href = link_pay
    }
  })

  const { doSubmit: doSubmitPagos, setDoSubmit: setDoSubmitPagos } = useSaveUpdate({
    data: dataSubmit,
    url: '/event/pagosonline/pay',
    setReload: ({ link_pay }) => {
      window.location.href = link_pay
    }
  })

  const getCoupon = async () => {
    try {
      setLoadingDelete(true)
      const requestCoupon = await doRequestPost({
        url: '/event/coupon/search',
        data: {
          p_key_coupon: coupon,
          p_id_customers: id_customers_reservation_event_zone
        }
      })

      if (requestCoupon.response !== 'success') {
        doToast({
          response: 'warning',
          message: requestCoupon.message,
          toast,
        })
        setCart({
          ...cart,
          id_coupon: '',
          type_coupon: '',
          amount_coupon: '',
          has2x1: false,
        })
      } else {
        const couponData = requestCoupon.data
        setCart({
          ...cart,
          id_coupon: couponData.id_coupon,
          type_coupon: couponData.type_coupon,
          amount_coupon: couponData.amount_coupon,
          has2x1: parseInt(couponData.has2x1) === 1,
        })
        setReload(true)
      }
    } catch (error) {
      doToast({
        response: 'error',
        message: 'No se pudo consultar el cupón',
        toast,
      })
      setCoupon('')
      setCart({
        ...cart,
        id_coupon: '',
        type_coupon: '',
        amount_coupon: '',
        has2x1: false,
      })
    } finally {
      setLoadingDelete(false)
    }
  }

  const removeCoupon = async () => {
    try {
      setLoadingDelete(true)
      const requestCoupon = await doRequestPost({
        url: '/event/coupon/delete',
        data: {
          p_id_customers: id_customers_reservation_event_zone
        }
      })

      if (requestCoupon.response !== 'success') {
        doToast({
          response: 'warning',
          message: 'El cupón no pudo ser eliminado',
          toast,
        })
      } else {
        setCart({
          ...cart,
          id_coupon: '',
          type_coupon: '',
          amount_coupon: ''
        })
        setCoupon('')
        setReload(true)
      }
    } catch (error) {
      doToast({
        response: 'error',
        message: 'No se pudo eliminar el cupón',
        toast,
      })
    } finally {
      setLoadingDelete(false)
    }
  }

  useEffect(() => {
    dispatch(setCustomerTime())
  }, [dispatch])

  const loading = useMemo(() => <LoadingIcon />, [])

  if (cart_loading) {
    return loading
  }

  return (
    <Layout title="Carrito de compras">
      <div className="container py-4 py-lg-5">
        {/* Encabezado */}
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-4">
          <div>
            <h1 className="h4 mb-1">Revisa tu compra</h1>
            <p className="text-muted mb-0">
              Confirma tus entradas, verifica tus datos y elige el método de pago.
            </p>
          </div>
          <div className="mt-3 mt-lg-0">
            <TimeCart />
          </div>
        </div>

        <FormCustom
          onSubmit={({ e }) => {
            e.preventDefault()

            if (cart?.details?.length === 0) {
              doToast({
                response: 'warning',
                message: 'No hay entradas en el carrito',
                toast,
              })
              return
            }

            const method = e.nativeEvent.submitter?.dataset?.method

            if (!method) {
              doToast({
                response: 'warning',
                message: 'Debes seleccionar un método de pago',
                toast,
              })
              return
            }

            dataSubmit.p_payment_method = method

            const totals = getSubtotal()
            savePendingPurchase({
              value: totals.total,
              currency: 'MXN',
            })

            if (method === 'mercado_pago') {
              setDoSubmit(true)
            } else if (method === 'pagos_online') {
              setDoSubmitPagos(true)
            }
          }}
          viewSubmit={false}
        >
          <div className="row">
            {/* Columna izquierda: entradas + datos de cliente */}
            <div className="col-lg-8 mb-4">
              {/* Entradas reservadas */}
              <Card className="mb-4 shadow-sm border-0">
                <Card.Body>
                  <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <h2 className="h5 mb-1">Entradas seleccionadas</h2>
                        <p className="text-muted mb-0">
                          Revisa los eventos, zonas y cantidades antes de continuar con el pago.
                        </p>
                      </div>
                    </div>

                    {(!cart?.details || cart.details.length === 0) && (
                      <p className="text-muted mb-0">
                        No tienes entradas en tu carrito.
                      </p>
                    )}

                    {cart?.details?.length > 0 && (
                      <div className="table-responsive mt-3">
                        <table className="table table-sm align-middle mb-0">
                          <thead className="thead-light">
                            <tr>
                              <th>Ticket</th>
                              <th className="text-center">Cantidad</th>
                              <th className="text-center">Importe</th>
                              <th className="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {React.Children.toArray(
                              cart.details.map(r => (
                                <tr>
                                  <td>
                                    <div className="fw-semibold">
                                      {r.name_event}
                                    </div>
                                    <div className="small text-muted">
                                      Zona: <strong>{r.name_event_zone}</strong>
                                    </div>
                                    {parseInt(r.id_type_event_zone) !== 1 && (
                                      <div className="small text-muted">
                                        Ubicaciones reservadas: {r.detail_reservated}
                                      </div>
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {parseInt(r.qty)}
                                  </td>
                                  <td className="text-center">
                                    <div className="d-flex justify-content-center align-items-center">
                                      <span>
                                        {parseFloat(
                                          r.total - parseFloat(r.charge_service_event_zone)
                                        ).toFixed(2)}{' '}
                                        {r.name_money}
                                      </span>
                                      {r.has_2x1 && (
                                        <span className="badge bg-info ms-2">
                                          Promo 2x1
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <i
                                      className="fa fa-trash text-danger cur-pointer"
                                      onClick={async () => {
                                        try {
                                          setLoadingDelete(true)
                                          await doRequestPost({
                                            url: '/event/zone/detail/clear',
                                            data: {
                                              p_id_event_zone_detail: r.id_event_zone_detail,
                                              p_id_customers: id_customers_reservation_event_zone,
                                            }
                                          })
                                          setLoadingDelete(false)
                                          setReload(true)
                                        } catch (error) {
                                          setReload(true)
                                        }
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </ReactPlaceholder>
                </Card.Body>
              </Card>

              {/* Información de comprador */}
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <h2 className="h5 mb-1">Datos del comprador</h2>
                        <p className="text-muted mb-0">
                          Utilizaremos esta información para enviarte los boletos y notificaciones.
                        </p>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <Input
                        classNameParent="col-md-6 mb-2"
                        text="Nombre(s)"
                        value={cart?.name_customer || ''}
                        disabled
                      />
                      <Input
                        classNameParent="col-md-6 mb-2"
                        text="Apellidos"
                        value={cart?.last_name_customer || ''}
                        disabled
                      />
                      <Input
                        classNameParent="col-md-6 mb-2"
                        text="Correo electrónico"
                        type="email"
                        disabled
                        value={cart?.email_customer || ''}
                      />
                      <Input
                        classNameParent="col-md-6 mb-2"
                        text="Teléfono"
                        value={cart?.phone_customer || ''}
                        disabled
                      />
                    </div>
                  </ReactPlaceholder>
                </Card.Body>
              </Card>
            </div>

            {/* Columna derecha: resumen + pago */}
            <div className="col-lg-4 mb-4">
              <Card className="shadow-sm border-0 position-sticky" style={{ top: '90px' }}>
                <Card.Body>
                  <ReactPlaceholder ready={ready} showLoadingAnimation rows={10}>
                    <h2 className="h5 mb-3">Resumen de tu orden</h2>

                    {/* Totales y cupón */}
                    {cart.id_coupon && cart.has2x1 !== 1 && (
                      <>
                        <div className="d-flex justify-content-between small mb-1">
                          <span>Subtotal antes de descuento</span>
                          <span>{getSubtotal().total_before_coupon} MXN</span>
                        </div>
                        <div className="d-flex justify-content-between small mb-3">
                          <span>Cupón aplicado</span>
                          <span className="text-success">
                            − {getSubtotal().amount_coupon} MXN
                          </span>
                        </div>
                      </>
                    )}

                    <div className="d-flex justify-content-between small mb-1">
                      <span>Subtotal</span>
                      <span>{getSubtotal().subtotal} MXN</span>
                    </div>
                    <div className="d-flex justify-content-between small mb-1">
                      <span>Cargo por servicio</span>
                      <span>{getSubtotal().total_charge_service} MXN</span>
                    </div>
                    <div className="d-flex justify-content-between small mb-3">
                      <span>Cargo por orden</span>
                      <span>{getSubtotal().cargo_por_orden} MXN</span>
                    </div>

                    <hr />

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="fw-semibold">Total a pagar</span>
                      <span className="fw-bold h5 mb-0">
                        {getSubtotal().total} MXN
                      </span>
                    </div>

                    {/* Cupón */}
                    {cart.has2x1 !== 1 && (
                      <div className="mb-3">
                        <p className="small text-muted mb-1">¿Tienes un cupón?</p>
                        <Input
                          classNameParent="mb-0"
                          placeholder="Código de descuento"
                          value={coupon}
                          onChange={e => setCoupon(e.target.value)}
                          disabled={!isNaN(parseInt(cart.id_coupon))}
                          append={[
                            isNaN(parseInt(cart.id_coupon)) ? (
                              <Button
                                key="aplicar"
                                variant="info"
                                size="lg"
                                onClick={getCoupon}
                                className="text-white"
                              >
                                Aplicar
                              </Button>
                            ) : (
                              <Button
                                key="quitar"
                                variant="danger"
                                size="sm"
                                onClick={removeCoupon}
                                className="text-white"
                              >
                                Quitar
                              </Button>
                            ),
                          ]}
                          onKeyPress={e => {
                            if (e.key === 'Enter') e.preventDefault();
                          }}
                        />
                      </div>
                    )}

                    <hr />

                    {/* Métodos de pago */}
                    <p className="small text-muted mb-2">
                      Selecciona tu método de pago para finalizar la compra:
                    </p>

                    <Button
                      className="mt-2 w-100 text-white"
                      type="submit"
                      variant="info"
                      data-method="mercado_pago"
                      size="lg"
                    >
                      Pagar con Mercado Pago
                    </Button>

                    {/* <Button
                      className="mt-3 w-100 text-white"
                      type="submit"
                      variant="danger"
                      data-method="pagos_online"
                      size="lg"
                    >
                      Pagar con Santander
                    </Button> */}
                  </ReactPlaceholder>
                </Card.Body>
              </Card>
            </div>
          </div>
        </FormCustom>

        {(doSubmit || doSubmitPagos) && loading}
        {loadingDelete && loading}
        {isProcessing && loading}
      </div>
    </Layout>
  )
}
